module.exports = __webpack_public_path__ + "static/img/2en.34f1984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/2en.png
// module id = SLLH
// module chunks = 0